import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';
import { useActiveUserContext, useDataRequestPermissionsContext } from '@vivli/core/infrastructure/context';
import { useEffect, useState } from 'react';
import { DataRequestStatusEnum } from '@vivli/features/data-requests/infrastructure/enum';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

export function useResearchTeamPermissions(dataRequest: IDataRequest, isAdminEditing: boolean = false) {
    const [userCanEdit, setUserCanEdit] = useState(false);
    const [userCanDelete, setUserCanDelete] = useState(false);
    const [userCanManage, setUserCanManage] = useState(false);
    const { userIsOwner, userIsAdmin } = useDataRequestPermissionsContext();
    const { user, hasPermission } = useActiveUserContext();

    const handlePermissions = () => {
        const inDraft = dataRequest.status === DataRequestStatusEnum.Draft;
        const isDrOwnerOrAdmin = userIsOwner(dataRequest) || userIsAdmin(dataRequest);
        //user is Admin, or an owner if there are no admin
        const userIsAdminInDraft =
            inDraft &&
            (userIsAdmin(dataRequest) ||
                !(dataRequest.researchTeam?.researchTeamDetails?.some((tm) => tm.isAdmin) && userIsOwner(dataRequest)));

        //TODO PERMFE - redo with permissions+
        const isVivliAdmin = hasPermission(PermissionsEnum.DrActAdv);
        setUserCanEdit((isVivliAdmin && isAdminEditing) || (inDraft && isDrOwnerOrAdmin));
        setUserCanManage(isVivliAdmin || isDrOwnerOrAdmin);
        setUserCanDelete(isVivliAdmin || userIsAdminInDraft);
    };

    useEffect(() => {
        handlePermissions();
    }, [dataRequest, user, isAdminEditing]);

    return {
        userCanEdit,
        userCanManage,
        userCanDelete,
    };
}
